export default "__VITE_ASSET__77Cj92Nc__"